module.exports = "/assets/data/a9b96c7fc9f678344f53c42c7ac826dc-NE28.data.json";